/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsSweepstakesFormsToolkitsFieldsProps, CpdsSweepstakesFormsToolkitsCheckboxProps, CpdsSweepstakesFormsToolkitsRadioProps, CpdsSweepstakesSelectInputProps, CpdsSweepstakesFormsToolkitsPhoneNumberProps } from './typings';

import Fields from './sub-input-components/fields';
import LongInput from './sub-input-components/long-input-field';
import Checkbox from './sub-input-components/checkbox';
import Radio from './sub-input-components/radio';
import Select from './sub-input-components/select';
import PhoneNumber from './sub-input-components/phone-number';

const CpdsSweepstakesFormsToolkitsInputs: React.FC & {
  Fields: React.FC<CpdsSweepstakesFormsToolkitsFieldsProps>;
  LongInput: React.FC<CpdsSweepstakesFormsToolkitsFieldsProps>;
  Checkbox: React.FC<CpdsSweepstakesFormsToolkitsCheckboxProps>;
  Radio: React.FC<CpdsSweepstakesFormsToolkitsRadioProps>;
  Select: React.FC<CpdsSweepstakesSelectInputProps>;
  PhoneNumber: React.FC<CpdsSweepstakesFormsToolkitsPhoneNumberProps>;
} = () => {
  return null;
};

CpdsSweepstakesFormsToolkitsInputs.Fields = Fields;
CpdsSweepstakesFormsToolkitsInputs.LongInput = LongInput;
CpdsSweepstakesFormsToolkitsInputs.Checkbox = Checkbox;
CpdsSweepstakesFormsToolkitsInputs.Radio = Radio;
CpdsSweepstakesFormsToolkitsInputs.Select = Select;
CpdsSweepstakesFormsToolkitsInputs.PhoneNumber = PhoneNumber;

export { CpdsSweepstakesFormsToolkitsInputs };
 

